/// <reference types="@angular/localize" />

import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

const loadQuantumMetricScript = () => {
    if (!environment.quantumMetricScriptUrl) {
        return;
    }
 
    if (document.getElementById("quantum-metric-script")) {
        return;
    }
 
    const script = document.createElement("script");
    script.id = "quantum-metric-script";
    script.async = true;
    script.src = environment.quantumMetricScriptUrl;
 
    const nonceScript = document.querySelector<HTMLScriptElement>("script[nonce]");
    const nonce = nonceScript?.nonce || nonceScript?.getAttribute("nonce");
    if (nonce) {
        script.nonce = nonce;
    }
 
    document.head.appendChild(script);
};
 
loadQuantumMetricScript();
bootstrapApplication(AppComponent, appConfig).catch((err) =>
	console.error(err),
);
